import { NavLink } from "react-router-dom";

const ReportNavBar = () => {
	return (
		<div className="resilire">
			<nav>
				<ul>
					<li>
						<NavLink to="/timesheet">Timesheet (All Units)</NavLink>
					</li>
					<li>
						<NavLink to="/timesheetPaid">Timesheet (Paid Units)</NavLink>
					</li>
					<li>
						<NavLink to="/report/LoggedInUsers">Clocked In Users</NavLink>
					</li>
					<li>
						<NavLink to="/report/FlaggedEntries">Flagged Entries</NavLink>
					</li>
					<li>
						<NavLink to="/report/PaidEntriesByLocation">Paid Entries by Location</NavLink>
					</li>
					<li>
						<NavLink to="/report/AllEntriesByLocation">All Entries by Location</NavLink>
					</li>
				</ul>
			</nav>
		</div>
	)
};

export default ReportNavBar;
